function Footer() {
    return (
        <div className="footer">
            <p>Copyright &copy; 2023 tutorial</p>
        </div>
    )
}

export default Footer